<script setup lang="ts">
import CustomButton from "@/components/Button/Button.vue";
import CustomModal from "@/components/CustomModal/CustomModal.vue";
import { PropType } from "vue";
import { Trip } from "@/models/Trip";
import { useI18n } from "vue-i18n";

defineProps({
  showDeleteModal: Boolean,
  trip: Object as PropType<Trip>,
});

defineEmits<{
  'on-close': [void]
  'on-delete-click': [string]
}>();

const { t } = useI18n(); // Use the i18n instance
</script>

<template>
  <CustomModal :show="showDeleteModal">
    <div class="p-5 flex flex-col modalDelete">
      <div class="cursor-pointer self-end" type="default" @click="$emit('on-close')">
        <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18" />
      </div>
      <div class="p-3.5 flex flex-col gap-8">
        <h1 class="responsive-title-6 font-bold">{{ t('tripDeleteModal.deleteTrip') }}</h1>
        <p>
          {{ t('tripDeleteModal.confirmationMessage') }}
        </p>
        <div class="flex gap-4">
          <CustomButton type="black" class="self-start" :rounded="true" @click="$emit('on-delete-click', trip.uuid)">{{
    t('tripDeleteModal.deleteButton') }}</CustomButton>
          <CustomButton :outlined="true"
            class="self-start hover:bg-black hover:text-white hover:border-black transition-all" :rounded="true"
            @click="$emit('on-close')">{{ t('tripDeleteModal.cancelButton') }}</CustomButton>
        </div>
      </div>
    </div>
  </CustomModal>
</template>

<style scoped>

</style>
